module.exports = __webpack_public_path__ + "img/fengmian.82e0ee47.png";